export const getLines = ({ extraTitle, details, highlight, description } = {}) => [
  extraTitle || '',
  [details, highlight].filter(Boolean).join(' | '),
  description || '',
];
